import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid2,
  Chip,
  Divider,
  Button,
  CardActions,
} from "@mui/material";
import { BicciExpressOrderStatuses } from "../../../utils/objects/BicciExpressOrderStatuses";
import { translateStatesBicci } from "../../../utils/objects/translateStates";
import { useNavigate } from "react-router-dom";

const ResumenServices = ({ serviciosAct, mergedOrders }) => {
  //  console.log("serviciosAct", serviciosAct);
  const navigate = useNavigate();
  if (!serviciosAct || serviciosAct.length === 0) {
    return (
      <Typography textAlign="center" color="textSecondary">
        No hay servicios activos disponibles.
      </Typography>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Servicios Activos
      </Typography>
      <Grid2 container spacing={2}>
        {serviciosAct.map((servicio, index) => (
          <Grid2 item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ height: "100%" }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {servicio.name}
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {servicio.description}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Chip
                  label={servicio.isActive ? "Activo" : "Inactivo"}
                  color={servicio.isActive ? "success" : "default"}
                  size="small"
                />
              </CardContent>
            </Card>
          </Grid2>
        ))}
      </Grid2>

      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" gutterBottom>
          Últimas Operaciones
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Aquí puedes agregar información adicional sobre los servicios.
        </Typography>
        <Box container sx={{ mt: 1, display: "block" }}>
          {mergedOrders &&
            mergedOrders.length > 0 &&
            mergedOrders.map((order, index) => (
              <Card
                key={index}
                sx={{ height: "100%", minWidth: 200, mb: 1, padding: 1 }}
              >
                <CardContent sx={{ padding: 0 }}>
                  <Typography sx={{ fontWeight: 600 }} color="textSecondary">
                    {order.id} - {order.toAddress}-{" "}
                    {translateStatesBicci[order.status]}
                  </Typography>
                </CardContent>
                <CardActions
                  sx={{ justifyContent: "flex-end", padding: "8px" }}
                >
                  <Button
                    size="small"
                    onClick={() =>
                      navigate(`/dashboard/dispatch/details/${order.id}`)
                    }
                  >
                    Ir →
                  </Button>
                </CardActions>
              </Card>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ResumenServices;
